import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListCompaniesBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List companies</div>
          <div className="text">
            Returns a list of all companies associated with your company, ordered by created date.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: 'A string to search by company name',
                heading: 'search',
                subheading: 'string (optional)',
              },
              {
                description: 'the URL name of the segment you want to use to filter companies',
                heading: 'segment',
                subheading: 'string (optional)',
              },
              {
                description:
                  "The number of companies you'd like to fetch, between 1-100. Defaults to 10 if not specified.",
                heading: 'limit',
                subheading: 'number (optional)',
              },
              {
                description: (
                  <>
                    The <a href="#pagination">cursor</a> from a previous request.
                  </>
                ),
                heading: 'cursor',
                subheading: 'string (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with a "companies" property that contains an array of company objects.
            You'll also receive a "hasNextPage" boolean indicating whether additional companies are
            available and a "cursor" string to request the next page. If "search" is provided,
            "hasNextPage" will always be false and "cursor" will be null.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v2/companies/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v2/companies/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d limit=100 \\
    -d cursor=NTUzYzNlZjhiOGNkY2QxNTAxYmExMjNhXzIwMjUtMDItMDRUMTY6NDA6MDcuNTQxWl8x`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">{`{
    "hasNextPage": true,
    "cursor": "NTUzYzNlZjhiOGNkY2QxNTAxYmExMjNhXzIwMjUtMDItMDRUMTY6NDA6MDcuNTQxWl8x",
    "companies": [
      {
        "id": "company1",
        "created": "2022-06-17T12:44:38.797Z",
        "customFields": {
          "number": 1,
          "bool": true,
          "string": "test"
        },
        "domain": "example.com",
        "memberCount": 5,
        "monthlySpend": 100.23,
        "name": "company 1"
      }
    ]
  }`}</Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
